An array of child locations.

This is always `null` regardless of the existence of child locations.
